import {createColumnHelper} from '@tanstack/react-table';
import {
  DeleteButtonWithConfirmation,
  EditButton,
} from 'components/refinedev/action_buttons';
import {defaultQueryOptions} from 'pages/_utils';
import StateBoundary from '@/components/basic/StateBoundary';
import {useBulkDelete} from '@/components/refinedev/data-table/use-bulk-delete';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';
import {DataTable} from '@/components/data-table/data-table';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import {DataTableColumnHeader} from '@/components/data-table/data-table-column-header';

const thisResource = 'users';

const columnHelper = createColumnHelper<any>();

export const columns = [
  columnHelper.accessor('id', {
    id: 'id',
    meta: {label: 'ID'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('username', {
    id: 'username',
    meta: {label: 'Tên đăng nhập'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('roles', {
    id: 'roles',
    meta: {label: 'Vai trò'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => {
      return info.getValue()?.map((v, i) => <p key={i}>{v.name}</p>);
    },
  }),
  columnHelper.accessor('staff', {
    id: 'staff',
    meta: {label: 'Nhân viên'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => {
      const value = info.getValue();
      if (!value) return 'N/A';
      return [value.name, value.department?.name, value.job?.name].join(', ');
    },
  }),
  columnHelper.display({
    id: 'actions',
    meta: {label: 'Hành động'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => (
      <div className="flex flex-row">
        <EditButton id={String(info.row.getValue('id'))} resource={thisResource} />
        <DeleteButtonWithConfirmation
          id={String(info.row.getValue('id'))}
          resource={thisResource}
        />
      </div>
    ),
  }),
];

const UserList = () => {
  const {refineTable, tanstackTable} = useRefineTanstackDataTable(
    {
      resource: thisResource,
      sorters: {initial: [{field: 'id', order: 'asc'}]},
      queryOptions: defaultQueryOptions,
      syncWithLocation: true,
      meta: {
        with: {staff: {with: ['department', 'job']}},
      },
    },
    {columns},
  );

  const bulkDelete = useBulkDelete(thisResource, tanstackTable);

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={thisResource}
              table={tanstackTable}
              bulkActions={[bulkDelete]}
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

UserList.table_columns = columns;

export default UserList;
